
import { createReducer, on } from '@ngrx/store';
import { rehydrateDealer, validateDealer, validateDealerError, validateDealerSuccess, resetDealer, previewDealer, previewDealerSuccess, previewDealerError } from '../_actions/dealer-actions';
import { DealerValidationState } from '../_models/dealer';


export const initialState = null;


const _dealerValidationReducer = createReducer(initialState,
  on(validateDealer, (state, payload) => {
    console.log('reducer validateDealer', state, payload)
    return state;

  }),
  on(validateDealerSuccess, (state, payload) => {
    console.log('reducer validateDealerSuccess', state, payload)
    sessionStorage.setItem('dealer', JSON.stringify(payload))
    return payload;

  }),
  on(validateDealerError, (state, payload) => {
    console.log('reducer validateDealerError', state, payload)
    return {success: false};

  }),
  on(rehydrateDealer, (state, payload) => {
    console.log('reducer rehydrateDealer', state, payload)
    sessionStorage.setItem('dealer', JSON.stringify(payload))
    return payload;
  }),
  on(resetDealer, (state, payload) => {
    sessionStorage.removeItem('dealer')
    return null
  }),
  on(previewDealer, (state, payload) => {
    console.log('reducer previewDealer', state, payload)
    return state;
  }),
  on(previewDealerSuccess, (state, payload) => {
    console.log('reducer previewDealerSuccess', state, payload)
    return payload;
  }),
  on(previewDealerError, (state, payload) => {
    console.log('reducer previewDealerError', state, payload)
    return {success: false, type: 'preview'};
  })
);


export function dealerValidationReducer(state, action) {
  return _dealerValidationReducer(state, action);
}
